import type { UseActionResult } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { Logistic, ShipLogisticArgs } from '@ztechapps/common.contract'
import { shipLogisticQuery } from './graphql'

export type UseShipLogisticResult = UseActionResult<Logistic, ShipLogisticArgs>

export const useShipLogistic = (): UseShipLogisticResult =>
  useActionMutation<Logistic, ShipLogisticArgs>({ query: shipLogisticQuery })
